{
	"chooseName": "¡Elige un nombre!",
	"createNewAccount": "Crear nueva cuenta",
	"createSuggestedPlan": "Usar el plan de cuentas sugerido",
	"delete": "Eliminar plan de cuentas",
	"deleteBillPlanConfirmDialog": "¿Está seguro de que desea eliminar la cuenta \"{{name}}\"?",
	"deleteBillPlanSuccessNotification": "Cuenta {{name}} eliminada con éxito",
	"deleteConfirmDialog": "¿Está seguro de que desea eliminar el Plan de cuentas??",
	"deleteSuccessNotification": "Plan de cuentas eliminadas.",
	"downloadTemplate": "Descargar la plantilla Spreadsheet",
	"editPlanOfAccountsSuccess": "Plan de cuentas editado correctamente.",
	"enter": "enter",
	"errorNotification": "Subida de documento {{name}} fallido",
	"esc": "esc",
	"existingName": "Nombre ya existente",
	"export": "Exportar Spreadsheet",
	"hasBillsMessage": "Esta cuenta ya tiene transacciones asociadas.",
	"importSuccessNotification": "Plan de cuentas importadas correctamente.",
	"name": "Nombre",
	"onChangeSuccessNotification": "Documento {{name}} subido correctamente",
	"parent": "Categoría principal",
	"parentPlaceholder": "Seleccionar un nuevo padre...",
	"showTree": "Ver árbol del plan de cuentas",
	"showTreeTitle": "Árbol del plan de cuentas"
}
